import Vue from 'vue'
import VueRouter from 'vue-router'
import myIndex from '@/views/index'
import index from '@/views/index'
import about from '@/views/about'
import dz from '@/views/dz'
import sj from '@/views/sj'
import rz from '@/views/rz'
import cs from '@/views/cs'
import sz from '@/views/sz'
import sjd from '@/views/sj_detail'
import dzd from '@/views/dz_detail'
import szd from '@/views/sz_detail'
import dzrzd from '@/views/dzrz_detail'
import sjrzd from '@/views/sjrz_detail'
Vue.use(VueRouter)
//

const routes = [{
	//首页样式
	path: '/myIndex',
	name: 'myIndex',
	component: myIndex,
	meta: {
		isLogin: true
	}
},
{
	path: '/',
	component: myIndex
},
{
	
	path: '/index',
	name: 'index',
	component: index
},
{
	
	path: '/about',
	name: 'about',
	component: about
},
{
	
	path: '/dz',
	name: 'dz',
	component: dz
},
{
	
	path: '/sj',
	name: 'sj',
	component: sj
},
{
	
	path: '/rz',
	name: 'rz',
	component: rz
},
{
	
	path: '/sz',
	name: 'sz',
	component: sz
},
{
	
	path: '/cs',
	name: 'cs',
	component: cs
},
{
	
	path: '/sj_detail',
	name: 'sjd',
	component: sjd
},
{
	
	path: '/dz_detail',
	name: 'dzd',
	component: dzd
},
{
	
	path: '/sz_detail',
	name: 'szd',
	component: szd
},
{
	
	path: '/dzrz_detail',
	name: 'dzrzd',
	component: dzrzd
},
{
	
	path: '/sjrz_detail',
	name: 'sjrzd',
	component: sjrzd
},
]

const router = new VueRouter({
	mode: 'hash',
	routes,
	// 解决路由跳转后，不显示在首行
	scrollBehavior() {
			return { x: 0, y: 0 };
	}
})
// 全局守卫，受否需要登录通行证
router.beforeEach((to, from, next) => {
	if (to.meta.isLogin) {
		router.push('/Index')
	} else {
		next()
	}
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router
